import store from '@/store';

export function permission(router) {

	// 需要过滤的参数
	// var filterOptions = [
	//     'sign'
	// ];

	// url白名单
	// var whiteList = [
	//     'city'
	// ];

	// getStore

	router.beforeEach((to, from, next) => {
		// 有登录信息进行存储，并删除url上参数
		var query = Object.assign({}, to.query);
		if (query['p']) {
			console.log(query['s'], query['p'], query['paycard']);
			store.commit('setPhone', query['p']);

			store.commit('setSign', query['s']);
			store.commit('setpaycard', query['paycard']);
			delete query['s'];
			delete query['p'];
			delete query['paycard'];

			next({
				path: to.path,
				query: query
			})
		}

		// 白名单过滤
		// if(whiteList.find(d=>d==to.name)){
		//     next();
		//     return;
		// }
		if (to.name == 'city' ) {
			next();
			return;

		}
		if (to.name == 'shopping' ) {
			next();
			return;
		
		}




		// 没有店铺和城市跳转选择城市
		if (!store.getters.getCity && to.name != 'shop') {

			next({
				name: 'shop'
			})
			return;
		} else if (to.name == 'city') {
			next();
			return;
		}

		if (!store.getters.getStore && to.name != 'shop') {
			next({
				name: 'shop'
			})
		} else if (to.name == 'shop') {
			next();
			return;
		}

		next();
	})
}